export class ServiceInfoApiRoutes {
    public static EXPORT_GTFS = 'gtfs/async';
    public static DOWNLOAD_GTFS = 'gtfs/';
    public static TOWNS = 'towns';
}